import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MatTableDataSource, Sort, PageEvent, MatDialog } from '@angular/material';

import { AuthenticationService } from '../../../providers/auth.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { EstadoPropuesta } from '../../../interfaces/propuesta';
import { OrdenEstadoPropuestaDialog } from '../ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component';

@Component({
  selector: 'app-ver-estados-propuesta',
  templateUrl: './ver-estados-propuesta.component.html',
  styleUrls: ['./ver-estados-propuesta.component.scss']
})
export class VerEstadosPropuestaComponent implements OnInit {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaEstadosColumnas = ['ID', 'Descripcion', 'Orden', 'acciones'];
  estadosDataSource = new MatTableDataSource();
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtro: string = '';
  flujo_actual: any = {};
  flujos: any;
  // getUsuariosSuscripcion = new Subscription();

  usuariosCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  @Output() onChangeFlujo = new EventEmitter();


  constructor(
    private propuestaService: PropuestasService,
    public authenticationService: AuthenticationService,
    public dialogOrden: MatDialog
  ) {    
  }

  ngOnInit() {
    // set valores iniciales
    this.sort.active = 'ID';
    this.sort.direction = 'desc';
    this.page.pageIndex = 0;
    this.page.pageSize = +localStorage.getItem('itemsPorPagina') || 10;
    this.page.length = 0;   
    this.propuestaService.getFlujos().subscribe(
      respuesta => {
        this.flujos = respuesta.data;
        this.flujo_actual = this.flujos[0];
        this.onChangeFlujo.emit({flujo: this.flujo_actual});
        this.actualizarTabla();   
      }
    ) 
  }

cambiarFlujo(event){
  this.flujo_actual=event.value;
  this.onChangeFlujo.emit({flujo: this.flujo_actual});
  this.actualizarTabla(); 
}

  openDialogOrden() {

    let dialogOrden = this.dialogOrden.open(OrdenEstadoPropuestaDialog, {
      disableClose: true,
      width: '35vw',
      data: {
        // IdEstado: this.IdEstado
      }
    });

    dialogOrden.afterClosed().subscribe(() => {
      this.actualizarTabla();
    });

  }

  onFiltro(filterValue: string) {
    this.page.pageIndex = 0;
    this.filtro = filterValue.trim().toLowerCase();
    this.actualizarTabla();
  }

  sortData(sort: Sort) {
    this.page.pageIndex = 0;
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('itemsPorPagina', pageEvent.pageSize.toString()); // los items por pagina se recuerdan
    this.page = pageEvent;
    this.actualizarTabla();
  }

  public getFlow(){
    return this.flujo_actual;
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo
        this.cargando = true;
      }, 750);
      

      var filtros: any = { // array de filtros internos
        generico: this.filtro
      };
      this.propuestaService.getEstadosPropuestas({ 'filtros': { 'flujo_id': this.flujo_actual.id } }).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            let estados: EstadoPropuesta[] = [];
            respuesta.estados.forEach(element => {
              estados.push(
                new EstadoPropuesta(
                  element.id,
                  element.descripcion,
                  element.orden
                )
              )
            });
            this.estadosDataSource.data = estados;
            this.cargando = false;
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar

          }


        }
      )
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
  }
}
